import React from "react";
import SlideUpOnScroll from "./slide-up";
import {Failed, Success} from "./alert";
import GetInTouchInput from "./form_input";
import {ActionButton} from "./action-button";
import sneakPeek from '../assets/sneak-peek.svg';
import './sneak-peek.css';
import * as emailjs from "emailjs-com";

class SneakPeek extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fullName: '',
            companyName: '',
            email: '',
            phoneNumber: '',
            services: '',
            succes: false,
            error: ''
        }
    }

    sendRequest = () => {
        let request = 'Name: ' + this.state.fullName;

        // Should fill in email
        if (!this.state.email) {
            this.setState({
                success: false,
                error: 'Please fill out the email field. We will contact you using this email.'
            });
            return;
        }

        if (!!this.state.email) {
            request += '\n Email: ' + this.state.email;
        }

        if (!!this.state.industry) {
            request += '\n Industry: ' + this.state.industry;
        }

        if (!!this.state.businessName) {
            request += '\n Business name: ' + this.state.businessName;
        }

        if (!!this.state.colors) {
            request += '\n Colors: ' + this.state.colors;
        }

        if (!!this.state.services) {
            request += '\n Services: ' + this.state.services;
        }

        const templateParams = {
            to_email: this.state.email,
            from_email: this.state.email,
            title: 'Sneak Peek Request',
            request: "User email: " + this.state.email + "\n\nRequest:\n" + request,
            subject: 'Sneak Peek Request - BinaryFusion'
        };


        emailjs.send('service_4xmehup', 'template_oa9tg07', templateParams, 'SzxRcKLK0IJhNc3Wy')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                this.setState({
                    fullName: '',
                    email: '',
                    industry: '',
                    businessName: '',
                    colors: '',
                    services: '',
                    success: true,
                });
            }, (err) => {
                console.log('FAILED...', err);
                this.setState({
                    success: false,
                    error: 'Failed to send request. Please try again later.'
                });
            });
    }

    render() {
        return (

            <div id='get-in-touch-form-outer' className='page-padding'>

                <div className='sneak-peek-above' />

                <div id="sneak-peek-touch-form">
                    <div id="sneak-peek-left">
                        <div className='t2 mb-3'>
                            <SlideUpOnScroll> Sneak Peek </SlideUpOnScroll>
                        </div>

                        <div className='b2 mb-5'>
                            <SlideUpOnScroll>
                                We’d love to show you a quick preview of how your new website or mobile app could look—
                                just share a few details so we can tailor it for you! <br/> <br/>

                                Once we have this, we’ll send you a personalized sneak peek within a few days.
                            </SlideUpOnScroll>
                        </div>

                        <SlideUpOnScroll>
                            <img alt='computer vision icon' src={sneakPeek} />
                        </SlideUpOnScroll>

                    </div>

                    <div className='gap' />

                    <div id="sneak-peek-right">
                        <div className='git-row'>
                            <GetInTouchInput label="Full Name" value={this.state.fullName} onChange={e => this.setState({fullName: e.target.value})} />
                            <GetInTouchInput label="Email" value={this.state.email} onChange={e => this.setState({email: e.target.value})} />
                        </div>

                        <div className='git-row'>
                            <GetInTouchInput label="Industry" value={this.state.industry}  onChange={e => this.setState({industry: e.target.value})} />
                            <GetInTouchInput label="Business Name" value={this.state.businessName}  onChange={e => this.setState({businessName: e.target.value})} />
                        </div>

                        <div className='git-row'>
                            <GetInTouchInput label="Colors and styles you like " value={this.state.colors}  onChange={e => this.setState({colors: e.target.value})} />
                        </div>

                        <GetInTouchInput className='medium-input multi' label="Services or products you provide" value={this.state.services} onChange={e => this.setState({services: e.target.value})} />

                        <ActionButton className='primary-color white-color-txt align-self-end' onClick={() => this.sendRequest()} text="Send request" />

                        {this.state.success && <Success hide={() => this.setState({success: false})}/>}
                        {!!this.state.error && <Failed hide={() => this.setState({error: '', success: false})} content={this.state.error}/>}
                    </div>

                </div>

                <div className='space-100' />
            </div>
        );
    }
}

export default SneakPeek;